import type { EncryptionContext, EncryptionInfo } from "../types";

import { fromBuffer } from "./buffer";
import { decryptWithCryptoKey, getCryptoKey } from "./crypto-actions";

export const decrypt = async (
    { encryptedData, IV }: EncryptionInfo,
    { plaintextDataKey, context }: EncryptionContext,
): Promise<string> => {
    const cryptoKey = await getCryptoKey(plaintextDataKey);
    const plaintextBuffer = await decryptWithCryptoKey({ cryptoKey, data: encryptedData, context, iv: IV });
    const plaintext = fromBuffer(plaintextBuffer, "utf8");

    return plaintext;
};
